import { render, staticRenderFns } from "./inrush-tatics.vue?vue&type=template&id=76404f7d&scoped=true"
import script from "./inrush-tatics.vue?vue&type=script&lang=ts"
export * from "./inrush-tatics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76404f7d",
  null
  
)

export default component.exports